import { DEFAULT_PROJETO } from 'src/components/projetos/constants'
import {
  ProjetoPersonalizadoOffgridLoadings,
  ProjetoPersonalizadoOffgridModals,
  ProjetoPersonalizadoOffgridValidations,
} from './personalizadoOffgrid.types'


export const DEFAULT_PROJETO_PERSONALIZADO_OFFGRID = {
  ...DEFAULT_PROJETO,
  tipo: 'personalizado',
  segmento: 'distribuicao_offgrid',
};

export const createDefaultProjetoPersonalizadoOffgrid = () => JSON.parse(JSON.stringify(DEFAULT_PROJETO_PERSONALIZADO_OFFGRID))

export const DEFAULT_PROJETO_PERSONALIZADO_OFFGRID_VALIDATIONS: ProjetoPersonalizadoOffgridValidations = {
  gerador: false,
  estruturas: true,
  acessorios: true,
  finalizacao: true,
}

export const DEFAULT_PROJETO_PERSONALIZADO_OFFGRID_LOADINGS: ProjetoPersonalizadoOffgridLoadings = {
  calcularProjeto: false,
  salvarProjeto: false,
  estruturas: false,
  acessorios: false,
}

export const DEFAULT_PROJETO_PERSONALIZADO_OFFGRID_MODALS: ProjetoPersonalizadoOffgridModals = {
  detalhesComponenteId: null,
  faturamento: false,
  simulacaoFinanciamento: false,
}
